// @ts-check

/**
 * @typedef {import('@stripe/stripe-js').StripeConstructorOptions['locale']} StripeLocale
 */

/** @type {Record<string, StripeLocale>} */
const APP_TO_STRIPE_LOCALE = {
  'en-US': 'en',
  'es-CO': 'es-419',
  'es-MX': 'es-419',
  'es-PE': 'es-419',
  'pt-BR': 'pt-BR',
  'fr-FR': 'fr-FR',
  'nl-NL': 'nl',
  'zh-CN': 'zh',
};

/**
 * Normalizes an app/i18n locale to a Stripe.js supported locale.
 * @param {string} [appLocale] - Locale from CurrentLang, whitelabel, or mount override.
 * @returns {StripeLocale}
 */
export default function toStripeLocale(appLocale) {
  if (!appLocale || !String(appLocale).trim()) {
    return 'auto';
  }

  const normalized = String(appLocale).trim();

  const mapped = APP_TO_STRIPE_LOCALE[normalized];
  if (mapped) {
    return mapped;
  }

  return 'auto';
}
